import { useMutation } from "@tanstack/react-query";
import { imagineStore } from "@/stores/imagine.store";
import { aiServiceFetch } from "@/lib/ai-service-client";
import { HttpError } from "@/lib/http-error";

export function useDeleteFile() {
  const projectId = imagineStore.use.projectId();

  const { mutate: deleteFile } = useMutation({
    mutationFn: async (url: string) => {
      const body = { url };

      const response = await aiServiceFetch(
        `/api/projects/${projectId}/delete-file`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
      );

      if (!response.ok) {
        throw await HttpError.fromResponse(response);
      }

      const { success } = await response.json();
      if (!success) {
        throw new Error(`Failed to delete file`);
      }

      return true;
    },
    retry: 3,
  });

  return deleteFile;
}
